// extracted by mini-css-extract-plugin
module.exports = {"body":"InfoBlockBody_body__1FHA4"};